import { Link } from "react-router-dom";
import { Button } from "../Button";
import { Menu, Star, StarHalf, X } from "lucide-react";
import { useState } from "react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <div className="top-0 sticky z-50">
      <div className="px-4 md:px-8  py-4 flex items-center justify-between w-full bg-white">
        <Link to="/">
          <img
            src="/assets/JellositeLogoandWordmark05.png"
            alt=""
            className="w-38 h-10"
          />
        </Link>
        <ul className="md:flex items-center justify-center gap-18 hidden">
          <Link to="/">
            <li>Home</li>
          </Link>
          <Link to="/about">
            <li>About</li>
          </Link>
          <Link to="/pricing">
            <li>Pricing</li>
          </Link>
        </ul>
        <Link to="/signup" className=" cursor-pointer hidden md:block">
          <Button
            text={"Try for free"}
            className="bg-[#945bf5] rounded-[40px] transition-all duration-300 ease-in-out hover:bg-white hover:text-[#945bf5] hover:shadow-[0_0_0_2px_#945bf5]"
          />
        </Link>

        <button
          className="block md:hidden p-2 cursor-pointer"
          onClick={toggleSidebar}
          aria-label="Toggle Menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {/* <div className="bg-[#ECF494] md:flex items-center justify-center p-4 hiddden">
        <div className="flex items-center justify-center flex-col md:flex-row gap-3">
          <div className="flex items-center gap-2 justify-center">
            <Star size="20" color="#FACC15" fill="#FACC15" />
            <Star size="20" fill="#FACC15" color="#FACC15" />
            <Star size="20" color="#FACC15" fill="#FACC15" />
            <Star size="20" fill="#FACC15" color="#FACC15" />
            <StarHalf size="20" fill="#FACC15" color="#FACC15" />
          </div>
          <p className=" flex items-center justify-center gap-1 responsive-font-h3 text-[#1A1A1A]">
            TRUSTED BY BUSINESSES OWNERS:{" "}
            <p className="font-medium responsive-font-h3">92</p>
          </p>
        </div>
      </div> */}
      {/* BACKDROP */}
      <div
        className={`fixed inset-0 bg-black/50 z-40 transition-opacity duration-300 ${isOpen ? "opacity-100 visible" : "opacity-0 invisible"
          }`}
        onClick={toggleSidebar}
      />

      {/* SIDEBAR */}
      <aside
        className={`fixed inset-y-0 left-0 w-full bg-white shadow-lg z-50 transform transition-transform duration-500 ease-in-out
          ${isOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        <div className="flex items-center justify-between w-full p-4">
          <img src="/logo.png" alt="" className="w-13 h-10" />
          <X size={24} onClick={toggleSidebar} />
        </div>
        <nav className="flex flex-col p-6 space-y-4">
          <Link to="/" onClick={toggleSidebar}>
            Home
          </Link>
          <Link to="/about" onClick={toggleSidebar}>
            About
          </Link>
          <Link to="/pricing" onClick={toggleSidebar}>
            Pricing
          </Link>
          <Link to="/signup" onClick={toggleSidebar} className="mt-4">
            <Button text="Create your store" className="w-full" />
          </Link>
        </nav>
      </aside>
    </div>
  );
};

export default Navbar;
